import {FC} from "react";
import {useDataProvider, useNotify, useRefresh} from "react-admin";
import * as React from "react";
import {Button, createStyles, Divider, Grid, makeStyles, TextField, Theme, Tooltip , FormControlLabel , Checkbox } from "@material-ui/core";
import Title from "../../components/Title";
import { useHistory} from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {countries, server_companies, server_types} from '../../countries'
import HashToken from "./helpers/hashToken";
import NimbleToken from "./helpers/nimbleToken";
import AkamaiToken from "./helpers/akamaiToken";


import {HashTokenData} from "./helpers/types/hashTokenData";
import {NimbleTokenData} from "./helpers/types/nimbleTokenData";
import {AkamaiTokenData} from "./helpers/types/akamaiTokenData";
import VerizonToken from "./helpers/verizonToken";
import LimelightToken from "./helpers/limelightToken";


const CreateServer : FC = () => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const history = useHistory();
    const refresh = useRefresh();

    const [server_country, setCountry] = React.useState<any[]>([]);
    const [server_owner, setOwner] = React.useState<any>({});
    const [server_address, setAddress] = React.useState<any>("");
    const [base_url, setUrl] = React.useState<any>({});
    const [connections_threshold, setConn] = React.useState<any>({});
    const [out_rate_threshold, setOut] = React.useState<any>({});
    const [type, setType] = React.useState<any>("");
    const [credentials , setCredentials] = React.useState<any>("");
    const [hash , setHash] = React.useState<any>(false);
    const [nimble , setNimble] = React.useState<any>(false);
    const [akamai , setAkamai] = React.useState<any>(false);
    const [verizon , setVerizon] = React.useState<any>(false);
    const [limelight , setLimelight] = React.useState<any>(false);
    const [hash_value , setHashValue] = React.useState<any>('');
    const [nimble_value , setNimbleValue] = React.useState<any>('');
    const [akamai_value , setAkamaiValue] = React.useState<any>('');
    const [verizon_value , setVerizonValue] = React.useState<any>('');
    const [limelight_value , setLimelightValue] = React.useState<any>('');
    const [token_value , setTokenValue] = React.useState<any>('');
    const [app_name , setAppName] = React.useState<any>('');

    function splitAppName(app_name : string){
        try {
            return app_name.split(',');
        }
        catch (e){
            return [app_name];
        }

    }


    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                padding: 30
            },
            large: {
                marginTop: 10,
                marginLeft: 10,
                marginBottom: 10,
                width: theme.spacing(10),
                height: theme.spacing(10),
            }
        })
    );

    const classes = useStyles();

    const getHashToken : HashTokenData = (data : any) => {
        setTokenValue(data);
    }
    const getNimbleToken : NimbleTokenData = (data : any) => {
        setTokenValue(data);
    }
    const getAkamaiToken : AkamaiTokenData = (data : any) => {
        setTokenValue(data);
    }
    const getVerizonToken : AkamaiTokenData = (data : any) => {
        setTokenValue(data);
    }
    const getLimelightToken : AkamaiTokenData = (data : any) => {
        setTokenValue(data);
    }


    const onSubmit = (e) => {
        e.preventDefault()
        let countries = server_country.map(function(item) {
            return item['key'];
        });

        let app_name_array = typeof app_name ==='string' ? splitAppName(app_name) : app_name;

        let token_type = '';

        if (hash){token_type='hash'}
        else if (nimble){token_type='nimble_token'}
        else if (akamai){token_type='akamai'}
        else if (verizon){token_type='verizon'}
        else if (limelight){token_type='limelight'}

        const created = {
            server_owner: server_owner,
            server_country : countries,
            server_address : server_address,
            base_url : base_url,
            token : token_type,
            token_config : token_value,
            app_name : app_name_array,
            connections_threshold : parseInt(connections_threshold),
            out_rate_threshold : parseInt(out_rate_threshold)*1000000,
            server_type : type,
            credentials : credentials
        }

        dataProvider.create(
            'servers/create',
            {
                data: created,
            },
            {
                onSuccess: () => {
                    const timer: ReturnType<typeof setTimeout> = setTimeout(() => refresh(), 1000);
                    notify('Your Server was successfully created', 'info');
                    history.push("/servers");
                },
                onFailure: () => {
                    notify('Error: Your Server was not successfully created', 'warning');
                }
            },
        )
    }

    return (
        <div className={classes.root}>
            <div >
                <form >
                    <Title title="General Details"  description='General Details' paddingBottom={4} paddingLeft={5} paddingTop={4}/>
                    <Grid container spacing={2}>
                            <Grid item md={3}>
                                <Tooltip title="Company which owns the server" placement='top-end' aria-multiline>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        options={server_companies}
                                        getOptionLabel={(option) => option}
                                        fullWidth
                                        renderInput={(params) => <TextField {...params} label="Company" variant="outlined" />}
                                        onChange={(event, value) => {
                                            if (value)
                                                setOwner(value)
                                        }}
                                    />
                                </Tooltip>
                            </Grid>
                        <Grid item md={3}>
                            <Tooltip title="Countries where the server is going to serve" placement='top-end' aria-multiline>
                            <Autocomplete
                                multiple
                                id="tags-outlined"
                                options={countries}
                                getOptionLabel={(option) => option.name}
                                filterSelectedOptions
                                onChange={(event, value) => setCountry(value)} // prints the selected value
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Countries"
                                        placeholder="Countries"

                                    />
                                )}
                            />
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Title title="Server Details"  description='Server Details' paddingBottom={4} paddingLeft={5} paddingTop={4}/>
                    <Grid container spacing={2}>
                        <Grid item md={3}>
                            <Tooltip title="Hold the address where the server is going to be monitored
                                            Port depends on the provider (Nimble , Flussonic etc)" placement='top-end' aria-multiline>
                            <TextField
                                label="Server Address"
                                placeholder="Server Address"
                                variant="outlined"
                                fullWidth
                                onChange={e => {setAddress(e.target.value)}}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid item md={3}>
                            <Tooltip title="Holds the address where the server is going to serve streams
                                             Part of the Stream URL" placement='top-end' aria-multiline>
                            <TextField
                                label='Base Url'
                                placeholder="Base Url"
                                variant="outlined"
                                fullWidth
                                onChange={e => {setUrl(e.target.value)}}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid item md={3}>
                            <Tooltip title="Maximum number of connections that the server is going to handle
                                           " placement='top-end' aria-multiline>
                            <TextField
                                label='Connections Threshhold'
                                placeholder="Connections Threshhold"
                                variant="outlined"
                                fullWidth
                                onChange={e => {setConn(e.target.value)}}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid item md={3}>
                            <Tooltip title="Maximum bandwidth that the server can handle , unit is in Mbps" placement='top-end' aria-multiline>
                            <TextField
                                label='OutRate Threshhold(Mbps)'
                                placeholder="OutRate Threshhold"
                                variant="outlined"
                                fullWidth
                                onChange={e => {setOut(e.target.value)}}
                            />
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Title title="Server Type"  description='Server Type' paddingBottom={4} paddingLeft={5} paddingTop={4}/>
                    <Grid container spacing={2}>
                        <Grid item md={3}>
                            <Tooltip title="Type of the server that is going to serve streams" placement='top-end' aria-multiline>
                            <Autocomplete
                                id="combo-box-demo"
                                options={server_types}
                                getOptionLabel={(option) => option}
                                fullWidth
                                renderInput={(params) => <TextField {...params} label="Server Type" variant="outlined" />}
                                onChange={(event, value) => {
                                    if (value)
                                        setType(value)
                                }}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid item md={3}>
                            <Tooltip title="Credentials to use when the server protections is on (Apikey or other credentials depending on the server)" placement='top-end' aria-multiline>
                            <TextField
                                label='Credentials'
                                placeholder="Credentials"
                                variant="outlined"
                                fullWidth
                                onChange={e => {setCredentials(e.target.value)}}
                            />
                            </Tooltip>
                        </Grid>
                        <Grid item md={3}>
                            <Tooltip title="Application name is taken from the stream servers provides" placement='top-end' aria-multiline>
                                <TextField
                                    label='Application Name'
                                    placeholder="Application Name"
                                    variant="outlined"
                                    fullWidth
                                    onChange={e => {setAppName(e.target.value)}}
                                />
                            </Tooltip>
                        </Grid>
                    </Grid>
                    <Grid item md={8}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={hash}
                                        onChange={e => {setHash(e.target.checked)}}
                                        color="primary"
                                    />
                                }
                                label="AES encryption"
                            />
                        {hash ?
                            <Grid item md={3}>
                                <HashToken hash_token={getHashToken} init_value={hash_value}/>
                            </Grid>
                            :
                            ""
                        }

                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={nimble}
                                        onChange={e => {setNimble(e.target.checked)}}
                                        color="primary"
                                    />
                                }
                                label="Nimble Token"
                            />

                        {nimble ?
                            <NimbleToken nimble_token={getNimbleToken} nimble_key={typeof nimble_value === 'undefined' ? "" : nimble_value.key } window={typeof nimble_value === 'undefined'  ? "" : nimble_value.window}/>
                            :
                            ""
                        }
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={akamai}
                                        onChange={e => {setAkamai(e.target.checked)}}
                                        color="primary"
                                    />
                                }
                                label="Akamai Token"
                            />

                        {akamai ?
                            <AkamaiToken akamai_token={getAkamaiToken} akamai_key={typeof akamai_value === 'undefined' ? "" : akamai_value.key } window={typeof akamai_value === 'undefined'  ? "" : akamai_value.window}/>
                            :
                            ""
                        }
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={verizon}
                                    onChange={e => {setVerizon(e.target.checked)}}
                                    color="primary"
                                />
                            }
                            label="Verizon Token"
                        />

                        {verizon ?
                            <VerizonToken verizon_token={getVerizonToken} verizon_key={typeof verizon_value === 'undefined' ? "" : verizon_value.key } window={typeof verizon_value === 'undefined'  ? "" : verizon_value.window} verizon_protocol={typeof verizon_value === 'undefined'  ? "" : verizon_value.protocol}/>
                            :
                            ""
                        }
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={limelight}
                                    onChange={e => {setLimelight(e.target.checked)}}
                                    color="primary"
                                />
                            }
                            label="Limelight Token"
                        />

                        {limelight ?
                            <LimelightToken limelight_token={getLimelightToken} limelight_key={typeof limelight_value === 'undefined' ? "" : limelight_value.key } expire={typeof limelight_value === 'undefined'  ? "" : limelight_value.expire}/>
                            :
                            ""
                        }
                    </Grid>

                    <Title title="Sample URL"  description='Url that is going to be used by the devices in order to play the stream' paddingBottom={4} paddingLeft={5} paddingTop={4}/>
                    <Grid container spacing={2}>
                        <Grid item md={6}>
                            <TextField
                                disabled={true}
                                label='Sample url'
                                placeholder="Rating"
                                value={`http://${typeof base_url!= 'object' ? base_url : ""}/yWbXvr1S/testarbiter/playlist.m3u8`}
                                variant="outlined"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                    <div style={{ padding: 20 }}>
                        <Divider />
                    </div>
                    <Button
                        size="large"
                        color="primary"
                        variant="contained"
                        type="submit"
                        onClick={onSubmit}
                    >
                        Submit
                    </Button>
                </form>
            </div>
        </div>
    )
};
export default CreateServer;